import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames/bind";
import Camera from "./Camera";
import styles from "./WareHouse.module.css";
import axiosClientFSR from "../../../../services/axiosClientFSR";

const cx = classNames.bind(styles);
const WareHouse = ({ icon, name, show, parentShow, onClick, indexWareHouse, code, status, groupCode, record }) => {
  const [camera, setCamera] = useState([]);
  const [check, setCheck] = useState(false);
  const [size, setSize] = useState(1);
  const [pageEnd, setPageEnd] = useState(false);
  const serviceCode = '20230222000000000002';
  useEffect(() => {
    const getListCameraByCode = async () => {
      if (!pageEnd) {
        const res = await axiosClientFSR.get(`/camaiservice/get-list-camera?page=${size}&size=10`, {
          params: {
            status_active: status,
            group_code: groupCode ? groupCode : null,
            ai_already: record,
            ai_service_code: (serviceCode && record === 1) ? serviceCode : null,
            warehouse_code: code,
          }
        })
        if (res.data.length > 0) {
          setCamera(prev => [...prev, ...res.data])
        } else {
          setPageEnd(true)
        }
      }
    }
    getListCameraByCode()
  }, [code, name, size, pageEnd, status, groupCode, serviceCode])

  const onClicks = (data) => {
    onClick(data);
  };

  const handleScrollBar = (e) => {
    if (e.currentTarget.scrollHeight - e.currentTarget.scrollTop === e.target.clientHeight && !pageEnd) {
      setSize(size + 1)
    }
  }
  return (
    <div className={cx("item")}>
      <div onClick={(e) => onClicks(indexWareHouse)} className={cx("location")}>
        <span className={cx("icon")}>{icon}</span>
        <span className={cx("name")}>{name}</span>
      </div>
      {
        parentShow && show && (
          <div className={cx("warehouse")} onScroll={handleScrollBar}>
            {camera &&
              camera.map((item, index) => (
                <Camera
                  check={check}
                  key={index}
                  status={item?.CAMERA?.AI_CONFIG}
                  name={item?.CAMERA?.NAME_CAM}
                  camID={item?.CAMERA?.CODE}
                  setCheck={setCheck}
                  prioritized={item?.CAMERA?.PRIORITIZED}
                  index={index}
                />
              ))}
          </div>
        )
      }
    </div >
  );
};
WareHouse.propTypes = {
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  show: PropTypes.bool.isRequired,
  parentShow: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  index: PropTypes.number,
};
export default WareHouse;
